import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';
  import { useStore } from '@/store';

  import { ButtonContentType, ButtonWidgetObject } from '@/types/widgets/buttonWidget/buttonWidget';
  import { CLOSE_PLAYER_MODAL } from '@/store/actions/player';

  
  const __default__ = {
    name: 'PlayerModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    closeButton: { type: Boolean, default: true },
  },
  emits: ["closeModal"],
  setup(__props, { emit }: { emit: ({ (event: 'closeModal'): void }), expose: any, slots: any, attrs: any }) {

const { closeButton } = __props;

  

  const store = useStore();
  
  const isPlaying = ref(false);
  const timer = ref<ReturnType<typeof setTimeout> | null>(null);
  const videoWidget = ref<HTMLVideoElement | null>(null);

  const content = computed<ButtonWidgetObject>(() => store.state.player.modalContent);
  const isVideoContent = computed(function () {
    return content.value.contentType === ButtonContentType.VIDEO;
  });
  const isImageContent = computed(function () {
    return content.value.contentType === ButtonContentType.IMAGE;
  });

  const playVideo = () => {
    if (!videoWidget.value) return;

    videoWidget.value.currentTime = 0;
    videoWidget.value.play();
    isPlaying.value = true;
  };

  const toggleVideo = () => {
    if (isPlaying) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  const pauseVideo = () => {
    if (!videoWidget.value) return;

    videoWidget.value.pause();
    isPlaying.value = false;
  };

  const closeModal = () => {
    store.commit(CLOSE_PLAYER_MODAL);
    emit('closeModal');
  };

  const handleClickOutside = () => {
    closeModal();
  };

  onMounted(() => {
    const closeTime = content.value.idleTimeout || 120;
    timer.value = setTimeout(closeModal, closeTime * 1000);

    if (isVideoContent.value) playVideo();
  });

  onUnmounted(() => {
    if (!timer.value) return;

    clearTimeout(timer.value);
  });

return { __sfc: true,store, emit, isPlaying, timer, videoWidget, content, isVideoContent, isImageContent, playVideo, toggleVideo, pauseVideo, closeModal, handleClickOutside, ButtonContentType }
}

})